import {Component, OnInit} from '@angular/core';
import {AlertService, GroupService, UserService} from "../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {DeviceService} from "../services/device.service";
import {DeviceGroupService} from "../services/deviceGroup.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";

@Component({
    templateUrl: './deviceGroupForm.component.html',
    styleUrls: ['./deviceGroupForm.component.scss']
})

export class DeviceGroupFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private alertService: AlertService,
        private deviceGroupService: DeviceGroupService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Devices groups');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            prefix: ['', Validators.required],
        });

        if (!this.isAddMode) {
            this.deviceGroupService.getById(this.id)
                .pipe(first())
                .subscribe(x => {
                    this.f.name.setValue(x.name);
                    this.f.prefix.setValue(x.prefix);
                }, error => {
                    this.alertService.error(error);
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createDeviceGroup();
        } else {
            this.updateDeviceGroup();
        }
    }

    private createDeviceGroup() {
        this.deviceGroupService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Device group added successfully', { keepAfterRouteChange: true });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    private updateDeviceGroup() {
        this.deviceGroupService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
